import ContentfulImage from '@moxy/react-contentful-image';

const ContentfulImageRenderer = ({
  image: {
    fields: {
      title,
      file: { url, details: { image: { width, height } = {} } = {} } = {},
    } = {},
  } = {},
  ...rest
}) => (
  <ContentfulImage
    alt={title}
    width={width}
    height={height}
    image={url}
    {...rest}
  />
);

export default ContentfulImageRenderer;
